/*
 * @Description:
 * @Date: 2025-05-19 18:04:00
 */
import InvoiceMain from '../views/invoice-main.vue';
import DbgysInvoiceMain from '../views/invoice-dbgys-main.vue';
import { Tabs } from '../types';
import router from '@/router';
import appStore from '@/store';

export const route = [
  // 工业
  {
    path: '/main/i/invoice',
    name: 'i-invoice-main',
    meta: {
      title: '发票管理',
      functionCode: 1
    },
    component: InvoiceMain
  },
  // 服务商
  {
    path: '/main/a/invoice',
    name: 'a-invoice-main',
    meta: {
      title: '发票管理',
      functionCode: 2
    },
    component: InvoiceMain
  },
  // 供应商
  {
    path: '/main/s/invoice',
    name: 's-invoice-main',
    meta: {
      title: '发票管理',
      functionCode: 3
    },
    component: InvoiceMain
  },
  // 代办供应商
  {
    path: '/main/dbgys/invoice',
    name: 'dbgys-invoice-main',
    meta: {
      title: '发票管理',
      functionCode: 8
    },
    component: DbgysInvoiceMain
  }
];

/**
 * @description: 跳转发票列表，写死路径为判断
 * @return {*}
 */
export const pushInvoiceList = (query: {
  tab: Tabs;
  entName?: string;
  entId?: number;
}) => {
  const { info } = appStore.useUserStoreSetup;
  const PATH = {
    1: 'i',
    2: 'a',
    3: 's',
    8: 'dbgys'
  };
  router.push({
    path: `/main/${PATH[info.functionCode]}/invoice`,
    query
  });
};
